var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ma-2",attrs:{"elevation":"4","width":"990"}},[_c('v-card-text',[_c('vue-mathjax',{staticClass:"title text--primary",attrs:{"formula":_vm.formula}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }